import { yupResolver } from '@hookform/resolvers/yup';
import cs from 'classnames';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { LINKS } from '@/Module/Core/Constant';
import { yup } from '@/Module/Core/Helper';
import type { ISearchProps } from '@/Module/DefaultLayout/Hook';
import { Button } from '@/Module/DesignSystem/Component';
import { IconClose } from '@/Module/Icon';
import { searchResultLessonSetResetSearchAction } from '@/Module/Search/Store/Slice/SearchResultSlice';
import { useAppDispatch } from '@/Module/Store/Hook';
interface ISearchBoxProps {
  isOpen: boolean;
  onToggle: ISearchProps['onToggle'];
}
interface IForm {
  query: string;
}
const SearchBox: FC<ISearchBoxProps> = ({
  isOpen,
  onToggle
}) => {
  const schema = yup.object().shape({
    query: yup.string().required()
  });
  const router = useRouter();
  const {
    register,
    handleSubmit,
    setValue
  } = useForm<IForm>({
    resolver: yupResolver(schema)
  });
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (`${router.pathname}/` !== LINKS.SEARCH) return;
    const searchText = router.query?.query?.toString() ?? '';
    setValue('query', searchText);
  }, [router]);
  const onSubmit = handleSubmit(data => {
    dispatch(searchResultLessonSetResetSearchAction());
    router.push({
      pathname: LINKS.SEARCH,
      query: {
        query: data.query
      }
    }, undefined, {
      shallow: `${router.pathname}/` === LINKS.SEARCH
    });
  });
  return <div className={cs('absolute top-1/2 mt-[-2px] w-[600px] md:w-[400px] max-w-searchBox md:max-w-[75vw] -translate-y-1/2 flex gap-2 items-stretch transition-all', 'bg-white rounded-full overflow-hidden border-[3px] border-blueSix shadow-searchBox shadow-blueSix', isOpen ? '-left-16 md:left-0 opacity-100 visible' : '-left-12 md:left-5 opacity-0 invisible')} data-sentry-component="SearchBox" data-sentry-source-file="SearchBox.tsx">
      <form className="flex flex-1" onSubmit={onSubmit}>
        <Button color="secondary" radius="none" bold className="rounded-l-none border-l-[3px] border-blueSix !shadow-none" onClick={onToggle} data-sentry-element="Button" data-sentry-source-file="SearchBox.tsx">
          جستجو
        </Button>

        <input className=" w-full flex-1 border-none pr-3 text-sm text-black md:text-base" placeholder="برای جستجو متنی را بنویسید ..." {...register('query')} />
      </form>
      <Button variant="text" color="gray" radius="circle" type="button" iconButton onClick={onToggle} data-sentry-element="Button" data-sentry-source-file="SearchBox.tsx">
        <IconClose data-sentry-element="IconClose" data-sentry-source-file="SearchBox.tsx" />
      </Button>
    </div>;
};
export default SearchBox;